var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrollDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V13C17 15.7614 14.7614 18 12 18C9.23858 18 7 15.7614 7 13V7ZM12 4.25C11.5858 4.25 11.25 4.58579 11.25 5V8C11.25 8.41421 11.5858 8.75 12 8.75C12.4142 8.75 12.75 8.41421 12.75 8V5C12.75 4.58579 12.4142 4.25 12 4.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45 18.4C8.11863 18.1515 7.64853 18.2186 7.4 18.55C7.15147 18.8814 7.21863 19.3515 7.55 19.6L11.55 22.6C11.8167 22.8 12.1833 22.8 12.45 22.6L16.45 19.6C16.7814 19.3515 16.8485 18.8814 16.6 18.55C16.3515 18.2186 15.8814 18.1515 15.55 18.4L12 21.0625L8.45 18.4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollDown);
export default __webpack_public_path__ + "static/media/scroll-down.9fba812bde84640f4da8b91f007b860a.svg";
export { ForwardRef as ReactComponent };